import React from "react";

export type LabelProps = { name: string; children: React.ReactNode };

function Label({ name, children }: LabelProps) {
  return <label htmlFor={name}>{children}</label>;
}

export default Label;
